import React from "react";
import {
  workImgOne,
  workImgTwo,
  workImgThree,
  workImgFour,
  workImgFive,
  workImgSix,
  workImgSeven,
} from "../../assets";
import Title from "../home/Title";
import ProjectsCard from "./ProjectsCard";
import { isItalianDevice } from "../../utils/utils";

const Projects = () => {
  return (
    <div>
      <Title
        title={isItalianDevice() ? "I Miei" : "My"}
        subTitle={isItalianDevice() ? "progetti" : "projects"}
      />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 lgl:gap-10">
        <div className="px-6">
          <ProjectsCard
            title="Sudokuspark"
            category="iOS & Android app"
            image={workImgThree}
            href={"https://sudokuspark.web.app"}
          />
          <ProjectsCard
            title="Poetrify"
            category="iOS & Android app"
            image={workImgOne}
            href={"https://poetrify.web.app"}
          />

          <ProjectsCard
            title="Polltrix"
            category="iOS & Android app"
            image={workImgFive}
            href={"https://polltrix.web.app"}
          />
        </div>
        <div className="px-6">
          <ProjectsCard
            title="Secretmob"
            category="iOS & Android app"
            image={workImgFour}
            href={"https://secretmob.web.app"}
          />
          <ProjectsCard
            title="JsonDupliCleaner"
            category="Web App"
            image={workImgTwo}
            href={"https://jsonduplicleaner.web.app"}
          />
          <ProjectsCard
            title="Animals Aid Tracker"
            category="iOS & Android app"
            image={workImgSix}
            href={"https://animalsaidtracker.web.app"}
          />
          <ProjectsCard
            title="Speed Math Challenge"
            category="iOS & Android app"
            image={workImgSeven}
            href={"https://speedmathchallenge.web.app"}
          />
        </div>
      </div>
    </div>
  );
};

export default Projects;
